













































import { Vue, Component } from 'vue-property-decorator'
import copy from '../../utils/copy'
import FileSave from 'file-saver'

@Component({
  props: ['agent']
})
export default class extends Vue {

  agents: Array<any> = [];
  title: string = '';
  limit: number = 50;
  load: number = 50;
  snackbar: boolean = false;

  created () {
    const data = this.$store.state.data;
    const list = Object.keys(data).map((name: string) => {
      if (this.$store.getters.slug(name) === this.$props.agent) {
        this.title = name;
        return data[name];
      }
    }).filter(n => n)
    if (list.length > 0) {
      this.agents = list[0];
      if (this.agents.length < this.load) {
        this.limit = this.agents.length;
      }
    } else {
      this.$router.push('/');
    }
    this.checkScroll()
  }

  checkScroll () {
    window.onscroll = () => {
      var d = document.documentElement;
      var offset = d.scrollTop + window.innerHeight;
      var height = d.offsetHeight;
      if (offset >= height - 200) {
        if (this.limit <= this.agents.length) {
          this.limit += (this.limit + this.load >= this.agents.length) ? this.agents.length - this.limit : this.load;
        }
      }
    }
  }

  copyAgent (text: string) {
    copy(text);
    this.snackbar = true;
  }

  download () {
    const blob = new Blob([this.agents.join('\r\n')], { type: 'text/plain?charset=utf-8'});
    FileSave.saveAs(blob, `${this.$props.agent}.txt`);
  }

}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/user-agent/_agent.vue